module.exports = __webpack_public_path__ + "static/media/FAQ.aaac237d.svg";